const Contrast = () => {
  return (
    <svg
      width="95"
      height="95"
      viewBox="0 0 95 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.105469"
        width="94.8943"
        height="94.8943"
        rx="47.4471"
        transform="rotate(0.0638669 0.105469 0)"
        fill="none"
      />
      <path
        d="M67.6152 27.4244L26.3751 68.5727C21.1079 63.2937 17.8531 56.0068 17.8621 47.9661C17.88 31.8846 30.9461 18.8476 47.0276 18.8655C55.0683 18.8744 62.348 22.1455 67.6152 27.4244Z"
        stroke="black"
        strokeWidth="5.24396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.1369 48.0309C76.119 64.1124 63.0528 77.1495 46.9714 77.1315C38.9306 77.1226 31.651 73.8515 26.3838 68.5726L67.6239 27.4243C72.8911 32.7033 76.1459 39.9902 76.1369 48.0309Z"
        stroke="black"
        strokeWidth="5.24396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.6367 60.3374L51.0784 76.8451"
        stroke="black"
        strokeWidth="5.24396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.9258 50.0649L64.0741 69.2267"
        stroke="black"
        strokeWidth="5.24396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.2461 39.7627L73.5503 58.137"
        stroke="black"
        strokeWidth="5.24396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Contrast;
